<template>
  <div>

    <!-- =========================
         SEARCH / SORT / DATE
    ========================== -->
    <div
      class="flex items-center justify-between"
      style="height: 40px"
    >
      <div class="h-full flex items-center">

        <!-- SORT -->
        <el-dropdown>
          <button
            class="sort-button flex items-center justify-center rounded-md h-full mr-3"
            :class="{ 'shadow-sm': sortList }"
            style="width: 40px; height: 40px; background-color: #f7fafd"
          >
            <sort-icon />
          </button>

          <el-dropdown-menu
            slot="dropdown"
            placement="right-end"
          >
            <el-dropdown-item disabled>
              SORT BY
            </el-dropdown-item>

            <el-dropdown-item>
              <button
                @click="setSortOrder('ASC')"
                class="flex items-center"
              >
                ASC
              </button>
            </el-dropdown-item>

            <el-dropdown-item>
              <button
                @click="setSortOrder('DESC')"
                class="flex items-center"
              >
                DESC
              </button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <!-- SEARCH -->
        <div class="flex items-center mr-8">
          <div class="table__search-input-wrapper flex items-center px-3">

            <span class="pr-2">
              <search-icon />
            </span>

            <input
              type="text"
              class="table__search-input"
              placeholder="Search..."
              v-model="queryString"
            />

            <div
              @click="showSearchFilter = true"
              class="cursor-pointer"
            >
              <search-drop-down-icon />
            </div>

          </div>
        </div>

      </div>

      <!-- DATE -->
      <div class="date-picker flex items-center justify-center">

        <el-date-picker
          type="date"
          placeholder="Start Date"
          style="margin: 0"
          class="mr-3"
          v-model="startDate"
        />

        <el-date-picker
          type="date"
          placeholder="End Date"
          style="margin: 0"
          v-model="endDate"
        />

      </div>
    </div>


    <!-- =========================
         TABLE
    ========================== -->
    <div class="table-values">

      <div
        v-if="outgoingSingleShipments && outgoingSingleShipments.length"
        class="table-wrapper"
        id="table-wrapper"
      >

        <table class="custom-table responsive-table">

          <!-- =========================
               TABLE HEADER
          ========================== -->
          <thead>
            <tr>

              <th class="width-xs">
                <input
                  type="checkbox"
                  class="checkbox"
                />
              </th>

              <th
                v-for="header in activeHeaders"
                :key="header.name"
              >
                {{ header.name }}
              </th>

              <th
                class="relative width-xs"
                tabindex="-1"
              >
                <span
                  class="cursor-pointer"
                  @click="showFilterModal = true"
                >
                  <img
                    src="../../../../assets/images/icons/options-icon.png"
                    class="inline-block"
                  />
                </span>
              </th>

            </tr>
          </thead>


          <!-- =========================
               TABLE BODY
          ========================== -->
          <tbody>

            <tr
              v-for="dispatch in outgoingSingleShipments"
              :key="dispatch.id"
            >

              <!-- CHECKBOX -->
              <td>
                <base-checkbox
                  label=""
                  v-model="terms_of_use"
                  :bold="true"
                />
              </td>


              <!-- COLUMNS -->
              <td
                v-for="header in activeHeaders"
                :key="header.name"
              >

                <!-- STATUS -->
                <span
                  v-if="header.name === 'STATUS'"
                  class="rounded-xl overflow-wrap p-2 px-4 text-center"
                  :class="statusClass(dispatch.status)"
                >
                  {{
                    dispatch.status === "received" &&
                    currentTab === "outgoing"
                      ? "Handed-off"
                      : capitalize(dispatch.status)
                  }}
                </span>


                <!-- DESTINATION -->
                <span
                  v-else-if="header.name === 'DESTINATION'"
                >
                  {{ dispatch.destination || "N/A" }}
                </span>


                <!-- OTHER COLUMNS -->
                <span v-else>
                  {{
                    getNestedValue(
                      dispatch,
                      headerMap[header.name]
                    )
                  }}
                </span>

              </td>


              <!-- =========================
                   ACTIONS
              ========================== -->
              <td class="actions-column">

                <el-dropdown
                  trigger="click"
                  placement="bottom-end"
                >

                  <button
                    class="p-2 list-button w-full text-right text-[#6E6893] flex items-center justify-center"
                    type="button"
                  >
                    <img
                      src="../../../../assets/images/icons/more-action-icon.png"
                      alt="Actions"
                    />
                  </button>


                  <el-dropdown-menu slot="dropdown">


                    <!-- =================================
                         1. VIEW DETAILS
                    ================================== -->
                    <el-dropdown-item
                      v-if="canViewDetails(dispatch)"
                    >
                      <button
                        type="button"
                        class="action-button"
                        @click="viewDetails(dispatch)"
                      >

                        <div class="action-icon">
                          <img
                            src="../../../../assets/images/icons/view-details-manifest.png"
                            alt="View Details"
                          />
                        </div>

                        <p>
                          View Details
                        </p>

                      </button>
                    </el-dropdown-item>


                    <!-- =================================
                         2. VIEW TIMELINE
                    ================================== -->
                    <el-dropdown-item
                      v-if="canViewTimeline(dispatch)"
                    >
                      <button
                        type="button"
                        class="action-button"
                        @click="viewTimeline(dispatch)"
                      >

                        <div class="action-icon">
                          <img
                            src="../../../../assets/images/icons/view-details-timeline.png"
                            alt="View Timeline"
                          />
                        </div>

                        <p>
                          View Timeline
                        </p>

                      </button>
                    </el-dropdown-item>


                    <!-- =================================
                         3. UPDATE STATUS
                    ================================== -->
                    <el-dropdown-item
                      v-if="canUpdateStatus(dispatch)"
                    >
                      <button
                        type="button"
                        class="action-button"
                        @click="openStatusUpdate(dispatch)"
                      >

                        <div class="action-icon">
                          <img
                            src="../../../../assets/images/icons/update-arrows.png"
                            alt="Update Status"
                          />
                        </div>

                        <p>
                          Update Status
                        </p>

                      </button>
                    </el-dropdown-item>


                    <!-- =================================
                         4. CONFIRM RECEIPT
                    ================================== -->
                    <el-dropdown-item
                      v-if="
                        currentTab === 'incoming' &&
                        dispatch.status !== 'delivered'
                      "
                    >
                      <button
                        type="button"
                        class="action-button"
                        @click="confirmReceipt(dispatch)"
                      >

                        <div class="action-icon">
                          <img
                            src="../../../../assets/images/icons/hand-shake.png"
                            alt="Confirm Receipt"
                          />
                        </div>

                        <p>
                          Confirm Receipt
                        </p>

                      </button>
                    </el-dropdown-item>


                    <!-- =================================
                         5. PROCESS HANDOFF
                    ================================== -->
                    <el-dropdown-item
                      v-if="
                        currentTab === 'outgoing' &&
                        canProcessHandoff(dispatch)
                      "
                    >
                      <button
                        type="button"
                        class="action-button"
                        @click="processHandoff(dispatch)"
                      >

                        <div class="action-icon">
                          <img
                            src="../../../../assets/images/icons/hand-shake.png"
                            alt="Process Handoff"
                          />
                        </div>

                        <p>
                          Process Handoff
                        </p>

                      </button>
                    </el-dropdown-item>


                    <!-- =================================
                         6. PROCESS FULFILLMENT
                    ================================== -->
                    <el-dropdown-item
                      v-if="
                        currentTab === 'outgoing' &&
                        canProcessFulfillment(dispatch)
                      "
                    >
                      <button
                        type="button"
                        class="action-button"
                        @click="processFulfillment(dispatch)"
                      >

                        <div class="action-icon">
                          <img
                            src="../../../../assets/images/icons/process-fulfillment-icon.png"
                            alt="Process Fulfillment"
                          />
                        </div>

                        <p>
                          Process Fulfillment
                        </p>

                      </button>
                    </el-dropdown-item>


                    <!-- =================================
                         7. PUT ON HOLD
                    ================================== -->
                    <el-dropdown-item
                      v-if="
                        currentTab === 'outgoing' &&
                        canPutOnHold(dispatch)
                      "
                    >
                      <button
                        type="button"
                        class="action-button"
                        @click="openHold(dispatch.id)"
                      >

                        <div class="action-icon">
                          <img
                            src="../../../../assets/images/icons/hand-up.png"
                            alt="Put on Hold"
                            class="w-5 h-5"
                          />
                        </div>

                        <p>
                          Put on Hold
                        </p>

                      </button>
                    </el-dropdown-item>


                    <!-- =================================
                         8. CANCEL
                    ================================== -->
                    <el-dropdown-item
                      v-if="
                        currentTab === 'outgoing' &&
                        canCancel(dispatch)
                      "
                    >
                      <button
                        type="button"
                        class="action-button"
                        @click="openCancelDispatch(dispatch)"
                      >

                        <div class="action-icon">
                          <img
                            src="../../../../assets/images/icons/cancel-icon.png"
                            alt="Cancel"
                          />
                        </div>

                        <p>
                          Cancel
                        </p>

                      </button>
                    </el-dropdown-item>


                  </el-dropdown-menu>

                </el-dropdown>

              </td>

            </tr>

          </tbody>

        </table>

      </div>


      <!-- =========================
           EMPTY STATE
      ========================== -->
      <div
        v-else
        class="flex flex-col items-center gap-2 justify-center p-5 bg-white w-100 empty-state"
      >

        <empty-dispatch-icon />

        <p class="text-center">
          You have not dispatched any shipments yet.
          Start by creating dispatching available shipments.
        </p>

        <primary-button
          buttonText="Dispatch Shipment"
          :loading="false"
          @click="$router.push({ name: 'NewDispatch' })"
        />

      </div>

    </div>


    <!-- =========================
         UPDATE STATUS MODAL
    ========================== -->
    <UpdateStatusModal
      v-if="showupdateModal"
      :showmodal="showupdateModal"
      :selectedItem="selecetedFleet"
      :statuses="statuses"
      @close-modal="showupdateModal = false"
      @refetch-dispatch="refresh"
    />


    <!-- =========================
         PROCESS HANDOFF MODAL
    ========================== -->
    <ProcessHandOffModal
      v-if="processhandoffModal"
      :showModal="processhandoffModal"
      :dispatch="selecetedFleet"
      @refetch-dispatch="refresh"
      @close-modal="processhandoffModal = false"
    />


    <!-- =========================
         PUT ON HOLD MODAL
    ========================== -->
    <PutOnHoldModal
      v-if="showHoldModal"
      :showmodal="showHoldModal"
      @close-modal="showHoldModal = false"
      @open-confirm-modal="showHoldConfirmModal = true"
    />


    <PutOnHoldConfirmModal
      v-if="showHoldConfirmModal"
      :dispatchId="selectedFleetId"
      :showmodal="showHoldConfirmModal"
      @refetch-dispatch="refresh"
      @close-modal="showHoldConfirmModal = false"
    />


    <!-- =========================
         SEARCH FILTER
    ========================== -->
    <DSF
      v-if="showSearchFilter"
      :show-modal="showSearchFilter"
      :loading="loadingDispatches"
      :dispatches="paginatedList"
      @appliedRef="appliedReference"
      @close-modal="showSearchFilter = false"
    />

    <pagination-control :total="totalDispatch" :pageNumber="pageNumber" @pageNumber="setNumDisplayDispatch"
      @pageSize="pageSizeSet" />


    <!-- =========================
         TABLE FILTER
    ========================== -->
    <DispatchTableFilter
      v-if="showFilterModal"
      :show-modal="showFilterModal"
      :activeHeaders="activeHeaders"
      @close-modal="showFilterModal = false"
    />


    <!-- =========================
         CANCEL DISPATCH
    ========================== -->
    <CancelDispatchModal
      v-if="showCanceldispatch"
      :showmodal="showCanceldispatch"
      :dispatch="selecetedFleet"
      @close-modal="showCanceldispatch = false"
      @refetch-dispatch="refresh"
    />

  </div>
</template>


<script>
// import moment from "moment";

import UpdateStatusModal from "./Modals/update-status-modal.vue";
import CancelDispatchModal from "./Modals/CancelDispatchModal";
import ProcessHandOffModal from "./Modals/ProcessHandoffModal";
import DSF from "./Modals/DispatchSearchFilter.vue";
import DispatchTableFilter from "./Modals/DispatchTableFilter.vue";
import PaginationControl from "@/components/UI/pagination";

import PutOnHoldModal from "@/components/3pl/Operations/Dispatch/Modals/PutOnHoldModal.vue";
import PutOnHoldConfirmModal from "@/components/3pl/Operations/Dispatch/Modals/putOnHoldConfirmModal.vue";


export default {
  name: "HandOffTable",

  props: {
    currentTab: {
      type: String,
      default: "outgoing",
    },

    outgoingSingleShipments: {
      type: Array,
      default: () => [],
    },
  },


  components: {
    UpdateStatusModal,
    CancelDispatchModal,
    ProcessHandOffModal,
    PaginationControl,
    DSF,
    DispatchTableFilter,
    PutOnHoldModal,
    PutOnHoldConfirmModal,
  },


  data() {
    return {
      showCanceldispatch: false,

      selecetedFleet: {},

      showHoldConfirmModal: false,

      showSearchFilter: false,

      showupdateModal: false,

      terms_of_use: false,

      showFilterModal: false,

      processhandoffModal: false,

      showHoldModal: false,

      selectedFleetId: null,

      isLoading: false,

      loadingDispatches: false,

      sortList: false,

      queryString: "",

      startDate: "",

      endDate: "",

      sortOrder: "ASC",

      pageSize: 10,

      sortColumn: "",

      dispatchPerPage: 10,

      pageNumber: 1,

      totalDispatch: 0,

      removedTableData: [],

      isTableFilter: false,

      date: 0,

      location: "null",

      shippingServices: [],

      dispatches: [],

      locations: [],

      fleets: [],


      statuses: [
        {
          name: "Received",
          value: "received",
        },
        {
          name: "Ready",
          value: "ready",
        },
        {
          name: "Accidented",
          value: "accidented",
        },
        {
          name: "Delayed",
          value: "delayed",
        },
        {
          name: "In-bound",
          value: "in-bound",
        },
        {
          name: "Dispatched",
          value: "dispatched",
        },
        {
          name: "On-hold",
          value: "on-hold",
        },
      ],


      activeHeaders: [
        {
          name: "Consolidation ID",
        },
        {
          name: "Weight",
        },
        {
          name: "Shipment Count",
        },
        {
          name: "Sending 3PL",
        },
        {
          name: "Handoff Leg/EDD",
        },
        {
          name: "DESTINATION",
        },
        {
          name: "STATUS",
        },
      ],


      headerMap: {
        "Consolidation ID": "consolidationId",

        "Weight": "totalWeightKg",

        "Shipment Count": "shipmentCount",

        "Sending 3PL": "sending3PL.orgName",

        "Handoff Leg/EDD": "handoffLeg.display",

        "DESTINATION": "destination",

        "STATUS": "status",
      },
    };
  },


  computed: {

    locationId() {
      return this.$store.getters.currentLocationId;
    },


    startRange() {
      return (
        (this.pageNumber - 1) *
        Number(this.dispatchPerPage)
      );
    },


    endRange() {
      return (
        this.pageNumber *
        Number(this.dispatchPerPage)
      );
    },


    paginatedList() {
      return this.dispatches.filter(
        (item, index) =>
          index >= this.startRange &&
          index < this.endRange
      );
    },


    setparams() {
      return {
        pageSize: this.dispatchPerPage,
        pageNum: this.pageNumber,
      };
    },


    onDispatch() {
      const validStatuses = [
        "dispatched",
        "accidented",
        "received",
        "delayed",
      ];

      return this.dispatches.some((dispatch) =>
        validStatuses.includes(
          dispatch.status || dispatch.dispatchStatus
        )
      );
    },
  },


  watch: {

    currentTab() {
      this.refresh();
    },


    queryString() {
      this.refresh();
    },


    startDate() {
      this.refresh();
    },


    endDate() {
      this.refresh();
    },


    sortOrder() {
      this.refresh();
    },
  },


  mounted() {
  
  },


  methods: {

    // ==========================================
    // STATUS
    // ==========================================

    getDispatchStatus(dispatch) {
      return (
        dispatch.status ||
        dispatch.dispatchStatus ||
        ""
      );
    },


    statusClass(status) {
      const value = (status || "").toLowerCase();

      if (
        [
          "dispatched",
          "received",
          "process_handoff",
        ].includes(value)
      ) {
        return "status-green";
      }

      if (
        [
          "loading",
          "in-transit",
        ].includes(value)
      ) {
        return "status-yellow";
      }

      if (value === "ready") {
        return "status-pale";
      }

      if (
        [
          "on-hold",
          "in-bound",
        ].includes(value)
      ) {
        return "status-any";
      }

      if (
        [
          "accidented",
          "delayed",
          "canceled",
          "cancelled",
        ].includes(value)
      ) {
        return "status-red";
      }

      return "status-pale";
    },


    capitalize(value) {
      if (!value) {
        return "N/A";
      }

      const text = String(value).replace(/_/g, " ");

      return (
        text.charAt(0).toUpperCase() +
        text.slice(1)
      );
    },


    // ==========================================
    // IMPORTANT:
    // THIS FIXES:
    // "getNestedValue is not a function"
    // ==========================================

    getNestedValue(obj, path) {
      if (!obj || !path) {
        return "N/A";
      }

      const value = String(path)
        .split(".")
        .reduce((current, key) => {
          if (
            current === null ||
            current === undefined
          ) {
            return undefined;
          }

          return current[key];
        }, obj);

      if (
        value === null ||
        value === undefined ||
        value === ""
      ) {
        return "N/A";
      }

      return value;
    },


    // ==========================================
    // ACTION VISIBILITY
    // ==========================================

    canViewDetails(dispatch) {
      return !!dispatch;
    },


    canViewTimeline(dispatch) {
      return !!dispatch;
    },


    canUpdateStatus(dispatch) {
      if (!dispatch) {
        return false;
      }

      const status =
        this.getDispatchStatus(dispatch);

      const blockedStatuses = [
        "delivered",
        "canceled",
        "cancelled",
        "declined",
      ];

      return (
        this.currentTab === "outgoing" &&
        !blockedStatuses.includes(status)
      );
    },


    canProcessHandoff(dispatch) {
      if (!dispatch) {
        return false;
      }

      const status =
        this.getDispatchStatus(dispatch);

      return (
        this.currentTab === "outgoing" &&
        status !== "delivered" &&
        status !== "canceled" &&
        status !== "cancelled"
      );
    },


    canProcessFulfillment(dispatch) {
      if (!dispatch) {
        return false;
      }

      const status =
        this.getDispatchStatus(dispatch);

      return (
        this.currentTab === "outgoing" &&
        status !== "delivered" &&
        status !== "canceled" &&
        status !== "cancelled"
      );
    },


    canPutOnHold(dispatch) {
      if (!dispatch) {
        return false;
      }

      const status =
        this.getDispatchStatus(dispatch);

      return (
        this.currentTab === "outgoing" &&
        status !== "delivered" &&
        status !== "canceled" &&
        status !== "cancelled"
      );
    },


    canCancel(dispatch) {
      if (!dispatch) {
        return false;
      }

      const status =
        this.getDispatchStatus(dispatch);

      return (
        this.currentTab === "outgoing" &&
        status !== "delivered" &&
        status !== "canceled" &&
        status !== "cancelled"
      );
    },


    // ==========================================
    // 1. VIEW DETAILS
    // ==========================================

    viewDetails(dispatch) {
      if (!dispatch || !dispatch.id) {
        return;
      }

      this.$router.push({
        name: "DispatchManifest",

        params: {
          dispatchID: dispatch.id,
        },

        query: {
          type:
            dispatch.dispatchType ||
            dispatch.type ||
            "",
        },
      });
    },


    // ==========================================
    // 2. VIEW TIMELINE
    // ==========================================

    viewTimeline(dispatch) {
      if (!dispatch || !dispatch.id) {
        return;
      }

      this.$router.push({
        name: "DispatchTimeline",

        params: {
          dispatchID: dispatch.id,
        },
      });
    },


    // ==========================================
    // 3. UPDATE STATUS
    // ==========================================

    openStatusUpdate(dispatch) {
      if (!dispatch) {
        return;
      }

      this.selecetedFleet = dispatch;

      this.showupdateModal = true;
    },


    // ==========================================
    // 4. CONFIRM RECEIPT
    // ==========================================

    confirmReceipt(dispatch) {
      if (!dispatch || !dispatch.id) {
        return;
      }

      this.$router.push(
        `/operations/confirm-reciept/${dispatch.id}`
      );
    },


    // ==========================================
    // 5. PROCESS HANDOFF
    // ==========================================

    processHandoff(dispatch) {
      if (!dispatch || !dispatch.id) {
        return;
      }

      /*
       * Keep this as the existing route used
       * by your project.
       */
      this.$router.push({
        name: "ProcessHandoff",

        params: {
          dispatchID: dispatch.id,
        },

        query: {
          dispatch: dispatch,
        },
      });
    },


    // ==========================================
    // 6. PROCESS FULFILLMENT
    // ==========================================

    processFulfillment(dispatch) {
      if (!dispatch) {
        return;
      }

      /*
       * Emit this so the parent can handle it
       * if Process Fulfillment is implemented
       * there.
       */
      this.$emit(
        "process-fulfillment",
        dispatch
      );
    },


    // ==========================================
    // 7. PUT ON HOLD
    // ==========================================

    openHold(id) {
      if (!id) {
        return;
      }

      this.selectedFleetId = id;

      this.showHoldModal = true;
    },


    // ==========================================
    // 8. CANCEL
    // ==========================================

    openCancelDispatch(dispatch) {
      if (!dispatch) {
        return;
      }

      this.selecetedFleet = dispatch;

      this.showCanceldispatch = true;
    },


    // ==========================================
    // SEARCH
    // ==========================================

    appliedReference(value) {
      this.queryString = value || "";
    },


    // ==========================================
    // SORT
    // ==========================================

    setSortOrder(value) {
      this.sortOrder = value;
      this.sortList = true;
    },


    // ==========================================
    // PAGINATION
    // ==========================================

    pageSizeSet(value) {
      this.dispatchPerPage = value;
    },


    setNumDisplayDispatch(value) {
      this.pageNumber = value;
    },


    // ==========================================
    // REFRESH
    // ==========================================

    refresh() {
      /*
       * The actual dispatch data is owned by
       * the parent component.
       *
       * Tell the parent to reload it.
       */
      this.$emit("refetch-dispatch");
    },


    // ==========================================
    // TABLE SCROLL
    // ==========================================

    scrollLeft() {
      const container =
        document.getElementById(
          "table-wrapper"
        );

      if (container) {
        container.scrollLeft += 10000;
      }
    },


    // ==========================================
    // TABLE FILTER
    // ==========================================

    updateTableData(data) {
      const index =
        this.removedTableData.indexOf(data);

      if (index >= 0) {
        this.removedTableData.splice(index, 1);
      } else {
        this.removedTableData.push(data);
      }

      this.isTableFilter = false;

      this.scrollLeft();
    },
  },
};
</script>


<style lang="scss" scoped>

.table-values {

  p {
    font-weight: 500;
  }


  .status-green {
    background-color: #09B78A33;
    color: #09B78A;
    font-size: 14px;
  }


  .status-yellow {
    background-color: #FFA60033;
    color: #FFA600;
    font-size: 14px;
  }


  .status-pale {
    background-color: #10233E33;
    color: #10233E;
    font-size: 14px;
  }


  .status-any {
    background-color: #FFA60033;
    color: #FFA600;
    font-size: 14px;
  }


  .status-red {
    background-color: #D7263833;
    color: #D72638;
    font-size: 14px;
  }
}


/* ==========================================
   ACTION BUTTON
========================================== */

.action-button {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;

  width: 100%;

  padding: 8px;

  text-align: left;

  background: transparent;

  border: none;

  cursor: pointer;
}


.action-button:hover {
  background-color: #f7fafd;
}


.action-button p {
  margin: 0;
  white-space: nowrap;
}


.action-icon {
  width: 24px;

  margin-right: 10px;

  display: flex;
  align-items: center;
  justify-content: center;
}


.action-icon img {
  max-width: 20px;
  max-height: 20px;
}


/* ==========================================
   ACTIONS COLUMN
========================================== */

.actions-column {
  width: 60px !important;
  min-width: 60px !important;
}


/* ==========================================
   EMPTY STATE
========================================== */

.empty-state {
  min-height: 300px;
}


/* ==========================================
   TABLE
========================================== */

#table-wrapper {
  margin: 2rem 0 0;
  overflow-x: auto;
}


.table-wrapper,
.table-wrapper .custom-table {
  transform: rotateX(180deg);

  -ms-transform: rotateX(180deg);

  -webkit-transform: rotateX(180deg);
}


/* ==========================================
   SCROLLBAR
========================================== */

.table-wrapper::-webkit-scrollbar {
  cursor: pointer;

  width: 5px;

  height: 8px;
}


.table-wrapper::-webkit-scrollbar-track {
  background: #c4c4c4;
}


.table-wrapper::-webkit-scrollbar-thumb {
  background: #fab427;

  width: 5px;

  border-radius: 20px;
}


/* ==========================================
   TABLE
========================================== */

.custom-table {
  margin: 0;
}


th {
  color: rgba(25, 48, 77, 0.7);

  font-weight: 500;

  padding: 0.75rem;

  min-width: 10rem;
}


.width-xs {
  min-width: 3rem !important;
}


td {
  background: #ffffff;

  color: var(--primaryblue);

  font-weight: 500;

  border-radius: 2px;

  padding: 0.75rem;

  vertical-align: top;
}


td span {
  display: block;
}


/* ==========================================
   SEARCH
========================================== */

.table__search-input-wrapper {
  background: #f7fafd;

  width: 20rem;

  border: 1px solid #dae8f6;

  border-radius: 5px;

  height: 40px;
}


.table__search-input {
  width: 100%;

  outline: none;

  background: transparent;
}


.table__search-input::placeholder {
  color: #9aa8b8;
}

</style>